<template>
  <header style="position: unset; !important;margin-bottom: 5px;">
    <div class="container-fluid">
      <div class="row">
        <div class="header-filtering">
          <button id="show-filter">
            <img src="../../asset2/img/filter.svg">
          </button>
          <form method="post" style="padding-top: 4px;">
            <div class="filtering-form">
              <span class="close">&times;</span>
              <div class="styled-select">
                <SelectBox :items="regions" v-model="region"
                           @input="onFilterChange('region')">Viloyat
                </SelectBox>
              </div>
              <div class="styled-select">
                <SelectBox :items="districts" v-model="district"
                           @input="onFilterChange('district')">Tuman
                </SelectBox>
              </div>
              <div class="styled-select">
                <SelectBox :items="sections" v-model="section"
                           @input="onFilterChange('section')">Mavze
                </SelectBox>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

  require('../../asset2/css/main.min.css');

  export default {
    name: 'StatisticsHeader',

    data() {
      return {
        items: [],
        region: null,
        regions: [],
        district: null,
        districts: [],
        section: null,
        sections: []
      };
    },

    created() {
      this.loadRelatedData();
    },

    methods: {
      onFilterChange(changeField) {
        if (changeField === 'region') {
          this.getRegionDistricts();
        } else if (changeField === 'district') {
          this.getDistrictsSections();
        }
        this.$emit('onStaticFiltersChange', this.getParams());
      },

      getParams() {
        const params = {};
        if (this.region) {
          params.region = this.region;
        }
        if (this.district) {
          params.district = this.district;
        }
        if (this.section) {
          params.sectionUid = this.section;

          this.sections.forEach(function (item) {
            if(item.value && params.sectionUid && item.value ===params.sectionUid) {
              params.sectionName = item.text;
            }
          })
        }
        return params;
      },

      async loadRelatedData() {
        let [getFarmsReq] = await Promise.all([
          this.axios.get('monterre/getRegions')
        ]);
        if (getFarmsReq.data && getFarmsReq.data.data) {
          this.setSelectedItems(getFarmsReq.data.data, 'regions');
        }
      },

      setSelectedItems(items, code) {
        const mType = items.map(item => {
          return {text: item, value: item + ''};
        });
        mType.unshift({value: null, text: 'Select'});
        this[code] = mType;
      },

      setSelectedFarmItems(items, code) {
        const mType = items.map(item => {
          return {text: item.name, value: item.uuid + ''};
        });
        mType.unshift({value: null, text: 'Select'});
        this[code] = mType;
      },

      getRegionDistricts() {
        this.districts = [];
        this.axios.get('monterre/regionDistrict', {params: {regionName: this.region}})
            .then(response => {
              if (response.data.data && response.data.data) {
                this.setSelectedItems(response.data.data, 'districts');
              }
            })
            .catch(error => {
              if (error.response && error.response.data.status === 400) {
                this.$toastr.error(error.response.data.message);
              }
            });
      },

      getDistrictsSections() {
        this.sections = [];
        this.axios.get('monterre/districtSection', {params: {districtName: this.district}})
            .then(response => {
              if (response.data.data && response.data.data) {
                this.setSelectedFarmItems(response.data.data, 'sections');
              }
            })
            .catch(error => {
              if (error.response && error.response.data.status === 400) {
                this.$toastr.error(error.response.data.message);
              }
            });
      },

      async mounted() {
      }
    }

  };
</script>

<style scoped>

</style>
